<template>
    <div class="mc-report-view__table">
        <div class="row">
            <!-- Search -->
            <div class="col-md-12">
                <div class="mc-table-view">
                    <div id="tickets-table_filter" class="dataTables_filter text-md-end float-end">
                        <label class="
                    d-inline-flex
                    align-items-center
                    mc-table-view__search
                  ">
                            <i class="mc-fa fas fa-search"></i>
                            <b-form-input v-model="filter" type="search" :placeholder="$t('global.search') + '...'"
                                class="ms-2"></b-form-input>
                        </label>
                    </div>
                </div>
            </div>
            <!-- End search -->
        </div> 

        <div class="table-responsive my-3 border border-1" v-if="fields.length > 0">
            <b-skeleton-wrapper :loading="isLoading">
                <template #loading>
                    <b-card>
                        <b-skeleton-table :rows="3" :columns="fields.length"
                            :table-props="{ bordered: false, striped: true }">
                        </b-skeleton-table>
                    </b-card>
                </template>
                <b-table class="datatables" :items="listData" :fields="fields" responsive="md" show-empty
                    :empty-text="$t('global.emptyTable')" :per-page="perPage" :current-page="currentPage"
                    :empty-filtered-text="$t('global.emptyFilteredTable')" :filter="filter"
                    :filter-included-fields="filterOn" @filtered="onFiltered">
                    <template #cell(doorOpenedOn)="data">
                        <template v-if="data.item.doorOpenedOn">
                            {{ momentDateShortMonth(data.item.doorOpenedOn) }}<br />
                            <span class="text-muted">{{ momentTimeSeconds(data.item.doorOpenedOn) }}</span>
                        </template>
                        <span v-else>-</span>
                    </template>
                    <template #cell(doorClosedOn)="data">
                        <template v-if="data.item.doorClosedOn">
                            {{ momentDateShortMonth(data.item.doorClosedOn) }}<br />
                            <span class="text-muted">{{ momentTimeSeconds(data.item.doorClosedOn) }}</span>
                        </template>
                        <span v-else>-</span>
                    </template>
                    <template #cell(driver)="data">
                        {{ data.item.driver ? data.item.driver.fullname : '-' }}
                    </template>
                    <template #cell(vehicle)="data">
                        {{ data.item.vehicle ? data.item.vehicle.licensePlate : '-' }}
                    </template>

                    <template #cell(vehicleType)="data">
                        {{ data.item.vehicle ? (data.item.vehicle.vehicleType ?
                                data.item.vehicle.vehicleType.manufacturer : '-') : '-'
                        }} / {{
                                data.item.vehicle ? (data.item.vehicle.vehicleType ?
                                    data.item.vehicle.vehicleType.model : '-') : '-'
                        }} / {{
                                data.item.vehicle ? (data.item.vehicle.vehicleType ?
                                    data.item.vehicle.vehicleType.type : '-') : '-'
                        }}
                    </template>

                </b-table>
            </b-skeleton-wrapper>
        </div>
        <div class="row mt-3" v-if="fields.length > 0">
            <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
                <label class="d-inline-flex align-items-center">
                Menampilkan
                <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm" :options="pageOptions">
                </b-form-select>
                entri. <p>Menampilkan <strong>{{ filteredItems.length > 0 ? ((currentPage - 1) * perPage + 1) : 0 }}</strong> - <strong>{{ Math.min(filteredItems.length, (currentPage * perPage)) }}</strong> dari <strong>{{ filteredItems.length }}</strong></p>
                </label>
            </div>
            </div>
            <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
                <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="currentPage" :total-rows="totalRows == null ? rows : totalRows" :per-page="perPage"></b-pagination>
                </ul>
            </div>
            </div>
        </div>
    </div>
</template>
    
<script>
import { GET_REPORT_DOOR } from "@/services/api/report/report"
import moment from "moment";
import { Helper } from "@/mixin/helper";
import { Export } from "@/mixin/export";
import { EXPORT_PDF_REPORT_DOOR } from "@/services/api/report/pdf";
import { EXPORT_EXCEL_REPORT_DOOR } from "@/services/api/report/excel";
moment.locale("id");

export default {
    name: "DoorTable",
    mixins: [Helper, Export],
    data() {
        return {
            tableData: [],
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterVehicle: [],
            filterDriver: [],
            filterOn: [],
            reportDoor: {
                reportDoor: []
            },
            fields: [],
            isLoading: false,
            fileName: '',
            openSection: false,
            periode: [],
            filteredItems: [],
            test: '',
        };
    },
    computed: {
        /**
         * Total no. of records
         */
        rows() {
            return this.reportDoor.reportDoor.length;
        },
        listData() {
            return this.reportDoor.reportDoor;
        },
    },
    mounted() {
        // Set the initial number of items
        this.totalRows = this.reportDoor.reportDoor.length;
    },
    methods: {
        /**
         * Search the table data with search input
         */

        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.filteredItems = filteredItems;
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        refreshData(periode, filter, filterDriver, fields) {
            this.test = 'masuk';
            this.reportDoor.reportDoor = [];
            if (fields.length == 0) {
                this.reportDoor.reportDoor = [];
                return;
            }
            this.fields = fields;
            this.isLoading = true;
            this.periode = periode;
            var filters = {};
            if (filter !== undefined && filter.length > 0) {
                filters = {
                    vehicleId: filter
                }
            }

            var filterDrivers = {};
            if (filterDriver !== undefined && filterDriver.length > 0) {
                filterDrivers = {
                    driverId: filterDriver
                }
            }

            var filterVar = {
                startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
                endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
                ...filters,
                ...filterDrivers
            };

            var self = this;
            var getData = this.$apollo
                .query({
                    query: GET_REPORT_DOOR,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache'
                }).then(res => {
                    var data = res.data;
                    self.totalRows = data.reportDoor.reportDoor.length;
                    if (self.totalRows === 0) {
                        self.reportDoor.reportDoor = [];
                        self.isLoading = false;
                        return [];
                    }

                    self.reportDoor.reportDoor = data.reportDoor.reportDoor;
                    self.filteredItems = data.reportDoor.reportDoor;

                    self.isLoading = false;
                    self.test = 'beres';
                });

            return getData;
        },

        openTable(periode, filter, filterDriver, fields) {
            this.$nextTick(() => {
                setTimeout(() => {
                    this.refreshData(periode, filter, filterDriver, fields);
                    this.openSection = false;
                }, 500);
            })
        },

        downloadToExcel(periode, filter, filterDriver, fields) {
            var filters = {};
            if (filter !== undefined && filter.length > 0) {
                filters = {
                    vehicleId: filter
                }
            }
            var filterDrivers = {};
            if (filterDriver !== undefined && filterDriver.length > 0) {
                filterDrivers = {
                    driverId: filterDriver
                }
            }

            var filterVar = {
                startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
                endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
                column: fields.map(item => item.header),
                subtitle: `Periode : ${this.momentDateLongMonth(periode[0])} - ${this.momentDateLongMonth(periode[1])}`,
                ...filters,
                ...filterDrivers
            };

            var downloadProgress = {
                name: 'Pintu ' + moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY") + '.xlsx',
                periode: moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY"),
                downloadedAt: moment().format('DD MMM YYYY HH:mm:ss'),
                percentage: 0,
                type: 'excel'
            };
            this.$store.commit("report/saveProgress", downloadProgress);

            var percentage = 0;
            var intervalDownload = setInterval(() => {
                if (percentage < 75) {
                    percentage += 25;
                } else if (percentage == 75) {
                    percentage = 90;
                } else if (percentage == 90) {
                    clearInterval(intervalDownload);
                }
                this.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: percentage });
            }, 500);

            var self = this;
            this.$apollo
                .query({
                    query: EXPORT_EXCEL_REPORT_DOOR,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache'
                }).then(res => {
                    var isSuccessful = res.data.excelReportDoor.isSuccessful;
                    if (isSuccessful) {
                        clearInterval(intervalDownload);
                        self.$parent.$parent.$parent.refreshDownloadHistory();
                        setTimeout(() => {
                            self.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: 100 });
                            self.$store.commit("report/deleteProgress", downloadProgress);
                        }, 500);
                    } else {
                        clearInterval(intervalDownload);
                        self.$parent.$parent.$parent.refreshDownloadHistory();
                        setTimeout(() => {
                            self.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: 90 });
                            self.$store.commit("report/deleteProgress", downloadProgress);
                        }, 500);
                    }
                })
        },

        downloadToPdf(periode, filter, filterDriver, fields) {
            var filters = {};
            if (filter !== undefined && filter.length > 0) {
                filters = {
                    vehicleId: filter
                }
            }
            var filterDrivers = {};
            if (filterDriver !== undefined && filterDriver.length > 0) {
                filterDrivers = {
                    driverId: filterDriver
                }
            }
            var filterVar = {
                startDate: moment(periode[0] + ' 00:00:00.000').toISOString(),
                endDate: moment(periode[1] + ' 23:59:59.000').toISOString(),
                column: fields.map(item => item.header),
                subtitle: `Periode : ${this.momentDateLongMonth(periode[0])} - ${this.momentDateLongMonth(periode[1])}`,
                ...filters,
                ...filterDrivers
            };

            var downloadProgress = {
                name: 'Pintu ' + moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY") + '.pdf',
                periode: moment(periode[0]).format("DD MMM YYYY") + ' - ' + moment(periode[1]).format("DD MMM YYYY"),
                downloadedAt: moment().format('DD MMM YYYY HH:mm:ss'),
                percentage: 0,
                type: 'pdf'
            };
            this.$store.commit("report/saveProgress", downloadProgress);

            var percentage = 0;
            var intervalDownload = setInterval(() => {
                if (percentage < 75) {
                    percentage += 25;
                } else if (percentage == 75) {
                    percentage = 90;
                } else if (percentage == 90) {
                    clearInterval(intervalDownload);
                }
                this.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: percentage });
            }, 500);

            var self = this;
            this.$apollo
                .query({
                    query: EXPORT_PDF_REPORT_DOOR,
                    variables: {
                        filter: filterVar,
                    },
                    fetchPolicy: 'no-cache'
                }).then(res => {
                    var isSuccessful = res.data.pdfReportDoor.isSuccessful;
                    if (isSuccessful) {
                        clearInterval(intervalDownload);
                        self.$parent.$parent.$parent.refreshDownloadHistory();
                        setTimeout(() => {
                            self.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: 100 });
                            self.$store.commit("report/deleteProgress", downloadProgress);
                        }, 500);
                    } else {
                        clearInterval(intervalDownload);
                        self.$parent.$parent.$parent.refreshDownloadHistory();
                        setTimeout(() => {
                            self.$store.commit("report/updateProgress", { progress: downloadProgress, percentage: 90 });
                            self.$store.commit("report/deleteProgress", downloadProgress);
                        }, 500);
                    }
                })
        }
    },
};
</script>